module.exports = __webpack_public_path__ + "static/media/refresh_black_24dp.7e8bff5e.svg";